module.exports = __webpack_public_path__ + "assets/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4uaVIGxA-75c3d2.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4uaVIGxA.woff2
// module id = 857
// module chunks = 2